import { render, staticRenderFns } from "./ToolTab.vue?vue&type=template&id=5ca08c64&"
import script from "./ToolTab.vue?vue&type=script&lang=js&"
export * from "./ToolTab.vue?vue&type=script&lang=js&"
import style0 from "./ToolTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports